import { call, put, select, takeEvery } from 'redux-saga/effects';

import { selectors as applicationSelectors } from '../applications/reducers';
import { actions, types } from './reducers';

import api from '../api/api';


export function* fetchSignalsRequest() {
  try {
    const applicationId = yield select(applicationSelectors.getSelectedApplication);
    const { data } = yield call(
      api.fetchSignals,
      applicationId,
    );
    yield put(actions.fetchSignalsSuccess(data));
  } catch (error) {
    yield put(actions.fetchSignalsFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(types.FETCH_SIGNALS_REQUEST, fetchSignalsRequest);
}
